import * as paper from "paper";
import { mapGetters } from "vuex";
export default {
    data(){
        return {
            canvas: {
                shape: null,
                segment: null,
                path: null,
            },
            vector: {
                obj: null,
                start: null,
                items: {
                    solid: null,
                    dashed: null,
                },
                item: null,
            },
        }
    },
    watch: {
        sections(){
            this.__sections_redraw()
        }
    },
    computed: {
        ...mapGetters({
            sections: "sections/items",
            mode: "sections/currentMode",
            shape: "sections/currentShape",
            currentEquipmentConfig: "sections/currentEquipmentConfig",
            unitScale: 'projects/scale',
            scale: 'assets/scale',
            project: 'projects/item'
        }),
        section:{
            get(){
                return this.$store.getters['sections/item']
            },
            set(value){
                return this.$store.commit('sections/ITEM', value)
            }
        },
        isUnitScaleEnabled(){
            return this.mode == 'unit-scale'
        },
    },
    mounted(){
        this.canvas.shape= null,
        this.canvas.segment= null,
        this.vector= {
            obj: null,
            start: null,
            items: {
                solid: null,
                dashed: null,
            },
            item: null,
        }
        this.$eventbus.$on('section-update-roof-id', ()=>{
            this.section = this.__sections_find_parent_roof(this.section, false)
        })
    },
    methods: {

        __sections_clear(){
            if(this.vector.items.solid){
                this.vector.items.solid.forEach(obj => obj.remove());
            }
            if(this.vector.items.dashed){
                this.vector.items.dashed.remove();
            }
            if(this.vector.item) this.vector.item.remove();
            
            this.vector.items.solid = []
            this.vector.items.dashed = null
            this.vector.items.item = null
        },
        __sections_close(event, internal=false){
            let self = this;
            if((event.key !== 'escape' && !internal) || !self.canvas.shape ) return;
        
            self.__sections_clear()

            self.canvas.shape.closed = true;
            self.canvas.shape.fullySelected=false;
            
            self.vector.start = self.vector.obj = null;
            
            if(self.vector.item){
                self.vector.item.remove()
                self.vector.item = null
            }
            
            
            if(self.isUnitScaleEnabled){
                
                this.$store.dispatch('ui/modal', {
                    show: true,
                    size: 'sm',
                    component: 'unit-scale'
                });
            }else{
                this.__sections_setdata()
                this.__sections_create()
            }
            self.canvas.shape.remove()
            self.canvas.shape = null
        },
        __sections_setdata(){
            this.section = {};
            if(this.mode == 'equipment'){
                let equipment_config_id = this.currentEquipmentConfig.id
                this.section = {
                    equipment_detail: {
                        equipment_config_id: equipment_config_id
                    }
                }
            }

            this.section.coords = this.canvas.shape.segments.map(segment=>{
                return { x: segment.point.x * this.scale, y: segment.point.y * this.scale}
            });

            this.section.asset_detail_id = this.image.id
            this.section.label = this.section.label || ""
            // this.section.divalto_code_id = 1
            this.section.shape_type = this.shape
            const {x,y} = this.canvas.shape.bounds.center
            this.section.center_coords = {x, y}
            this.section.section_type = this.mode
            this.section.project_id = this.project.id
        },
        __sections_calculate_area(section){
            let shape = new paper.Path({
                strokeWidth: 1,
                strokeColor: new Color(1, 1,1, 0.01),
                fullySelected:false,
                closed: section.shape_type == 'polygon',
                fillColor: new Color(1, 1,1, 0.01)
            });
            section.coords.forEach(point=>{
                let x = point.x * this.unitScale
                let y = point.y * this.unitScale
                x = Math.round(x * 100) / 100
                y = Math.round(y * 100) / 100
                shape.add(new paper.Point(x, y))
            })
            let length = 0
            for(let i = 0; i < section.coords.length; i++){
                let start = i;
                let end = i+1;
                if(end == section.coords.length){
                    if(section.shape_type == 'polyline') continue
                    end = 0
                }
                start = section.coords[start]
                end = section.coords[end]
                let startPoint = new paper.Point(start.x * this.unitScale, start.y * this.unitScale);
                let endPoint = new paper.Point(end.x * this.unitScale, end.y * this.unitScale);
                let vector = endPoint.subtract(startPoint)
                length += Math.floor(vector.length * 100) / 100
            }

            section.area = Math.abs(shape.area)
            section.perimeter = length
            shape.remove()
            return section
        },
        __sections_find_parent_roof(section, isCreate){
            if(section.section_type == 'roof') return section
            let obj = null
            if(isCreate){
                obj = this.canvas.shape
            }else{
                obj = this.groups[section.id].obj.children[0]
            }
            console.log(section.id,section,obj)

            this.sections.filter(s => s.section_type == 'roof').forEach(roof => {
                let roofObj = this.groups[roof.id].obj.children[0]
                let isInside = true
                if(obj.isInside(roofObj.bounds)){
                    if(obj.segments){
                        obj.segments.forEach(s=>{
                            isInside = isInside && roofObj.contains(s.point)
                        })
                    }else{
                        isInside = isInside && roofObj.contains(obj.position)
                    }
                    if(isInside){
                        section.equipment_detail= {
                            ...section.equipment_detail,
                            roof_section_id: roof.id
                        }
                    }
                }
            });
            return section
        },

        __sections_calculate_properties(section, isCreate){
            if(section.section_type == 'roof') return section
            let obj = isCreate ? this.canvas.shape : this.groups[section.id].obj.children[0]
            console.log("calculate_properties ",section)
            let fields_data = isCreate ? this.currentEquipmentConfig.fields_data: section.equipment_detail.equipment_config.fields_data
                        
            if(fields_data.width || fields_data.length){
                if(!("data" in section.equipment_detail) || !section.equipment_detail.data){
                    section.equipment_detail.data = {}
                }
                let a = obj.segments[0].point
                let b = obj.segments[1].point
                let c = obj.segments[2].point

                let lineA = b.subtract(a)
                let lineB = c.subtract(b)

                let lenA = lineA.length * this.scale * this.unitScale
                let lenB = lineB.length * this.scale * this.unitScale
                
                lenA = Math.floor(lenA * 100) / 100 
                lenB = Math.floor(lenB * 100) / 100 
                if(!section.equipment_detail.data){
                    section.equipment_detail.data = {}
                }
                if(fields_data.width){
                    section.equipment_detail.data.width = (lenA > lenB ? lenB : lenA) * 100
                }
                if(fields_data.length){
                    section.equipment_detail.data.length = (lenA > lenB ? lenA : lenB) * 100
                }
            }
            
            return section
        }, 

        
        __sections_autoset(type='section'){
            let self = this
            let coords_arr = []
            let path = null
            if(type == "section"){
                coords_arr = this.section.coords
                if(![3,4].includes(coords_arr.length)){
                    return
                }
                
                path = new paper.Path({
                    strokeColor:"red"
                });
                coords_arr.forEach(s=>{
                    path.add([s.x,s.y])
                })        
            }
            if(type == 'canvas'){
                path = self.canvas.shape
            }
            
            let line = new paper.Path.Line({from:path.segments[0].point, to: path.segments[2].point})
            let center = line.bounds.center;
            
            let vector = path.segments[1].point.subtract(center);
            
            let last_point = path.segments[1].point.subtract(vector.multiply(2));
            if(path.segments.length == 4){
                path.removeSegment(3)
            }

            console.log("last_point", last_point)
            
            path.add(last_point)
            line.remove()
            if(type == 'section'){

                this.section.coords = []
                console.log("path.segments", path.segments.length)
                path.segments.forEach(sgt=>{
                    this.section.coords.push({
                        x: sgt.point.x,
                        y: sgt.point.y
                    })
                })

                this.$store.dispatch('sections/update', {
                    projectId: this.section.project_id,
                    id: this.section.id,
                    payload: {
                        section: this.section
                    },
                    config: {
                        params: {
                            include: ['equipment_detail', 'equipment_detail.equipment_config']
                        }
                    },
                })

                path.remove()
            }
        },

        __sections_create(){
            this.section = this.__sections_calculate_area(this.section)
            this.section = this.__sections_find_parent_roof(this.section, true)
            this.section = this.__sections_calculate_properties(this.section, true)
            this.$store.dispatch('sections/create', {
                projectId: this.section.project_id,
                payload: {
                    section: this.section
                },
                config: {
                    params: {
                        include: ['equipment_detail', 'equipment_detail.equipment_config']
                    }
                }
            }).then((res)=>{
                let section = res.data.data
                this.__sections_redraw()

                this.$store.dispatch('sections/selectItem', section.id)
                this.$store.dispatch('ui/projectSidebar.open', {
                    component: 'SectionInfoDrawer',
                    heading: `${section.section_type} Details`,
                    width: '400px',
                    right: true,
                    noHeader: true,
                    key: `section-${section.id}`
                })
            })
        },
        __sections_add(){
            let self = this;
            self.canvas.shape= new paper.Path({
                strokeColor: 'red',
                fullySelected:true,
                closed: false
            });
            
        },
        __sections_unselectAll(){
            this.$data._groups.map(function(item){
                item.fullySelected = false;
            })
        },
        __sections_processVector(event, drag) {
            let self = this;
            self.vector.obj = event.point.subtract(self.vector.start);
            this.__sections_drawVector(self, drag);
        },
        __sections_drawVector(self, drag) {
            this.__sections_clear()

            let arrowVector = self.vector.obj.normalize(10);
            let end = null
            if(self.vector.start && self.vector.obj){
                end = self.vector.start.add(self.vector.obj);
            }

            self.vector.item = new paper.Group([
                new paper.Path([self.vector.start, end]),
                new paper.Path([
                    end.add(arrowVector.rotate(135)),
                    end,
                    end.add(arrowVector.rotate(-135))
                ])
            ]);
            self.vector.item.strokeWidth = 0.75;
            self.vector.item.strokeColor = 'red';
            
            if (!drag){
                this.__sections_drawLength(self, self.vector.start, end, self.vector.obj.angle < 0 ? -1 : 1);
            }

            if(self.vector.items.dashed){
                let item = self.vector.items.dashed;
                item.strokeColor = 'black';
                item.dashArray = [1, 2];
                self.vector.items.solid.push(item);
            }
        },
        __sections_drawLength(self, from, to, sign) {

            let lengthSize = 5;
            if ((to.subtract(from)).length < lengthSize * 4)
                return;
            
            let vector = to && from ? to.subtract(from) : null;
            let awayVector = null;
            let upVector = null;
            awayVector = vector.normalize(lengthSize).rotate(90 * sign);
            upVector = vector.normalize(lengthSize).rotate(45 * sign);
            let downVector = upVector.rotate(-90 * sign);
            let lengthVector = vector.normalize(
                    vector.length / 2 - lengthSize * Math.sqrt(2));
            let line = new paper.Path();
            line.add(from.add(awayVector));
            line.lineBy(upVector);
            line.lineBy(lengthVector);
            line.lineBy(upVector);
            let middle = line.lastSegment.point;
            line.lineBy(downVector);
            line.lineBy(lengthVector);
            line.lineBy(downVector);
            // self.vector.items.dashed.push(line);
            self.vector.items.dashed = line;
            
            // Length Label
            let textAngle = Math.abs(vector.angle) > 90
                    ? 180 + vector.angle : vector.angle;
            // Label needs to move away by different amounts based on the   
            // vector's quadrant:t
            let away = (sign >= 0 ? [1, 4] : [2, 3]).indexOf(vector.quadrant) != -1
                    ? 8 : 0;
            
            let value = vector.length;

            /** Calculating Length for Original Sized Image */
            value = value * self.scale

            /** Calculate length as per unitScale for polygon mode */
            if(self.mode != 'unit-scale'){
                value = value * this.unitScale
            }

            let textObj = new paper.PointText({
                point: middle.add(awayVector.normalize(away + lengthSize)),
                content: (Math.floor(value * 1000) / 1000).toFixed(2) + self.unit.abbr,
                fillColor: 'black',
                justification: 'center'
            });
            
            textObj.rotate(textAngle);
            self.vector.items.solid.push(textObj);
            if(self.isUnitScaleEnabled){
                this.$store.commit('canvas/unitScale.pixel', Math.floor(value * 1000) / 1000)
            }
        
        },

        __sections_cancel(){
            let self = this
            self.__sections_clear()
            self.vector.start = self.vector.obj = null
            if(self.canvas.shape){
                self.canvas.shape.remove()
                self.canvas.shape = null
            }
            
            if(self.vector.item){
                self.vector.item.remove()
                self.vector.item = null
            }
        },
        __sections_hit_test(event){
            let self = this;
            if(["polygon", "polyline"].includes(this.shape)){
                if(self.canvas.shape && self.canvas.shape.segments && self.canvas.shape.segments.length){
                    let segments = self.canvas.shape.segments
                    let start = segments[0].point
                    let end = segments[segments.length-1].point
                    let isStart = event.point.isClose(start, 10)
                    let isEnd = event.point.isClose(end, 10)
                    if( ( (segments.length > 2 && this.shape == 'polygon') 
                        || (segments.length > 1 && this.shape == 'polyline')) 
                        && (isStart || isEnd)){
                        this.__sections_close(event, true)
                        return false
                    } 
                }
            }

            return true;
        },

        __sections_onMouseDown(event){
            let self = this;

            (self.canvas.shape == null) &&  self.__sections_add(event)

            if(self.vector.item) self.vector.item.remove();
            
            if(!this.__sections_hit_test(event))return;
            

            self.canvas.shape.add(new paper.Point(event.point.x,event.point.y));
            
            if(this.shape == 'marker'){
                this.__sections_close(event, true);
                return;
            }

            let end = null;

            if(self.vector.start && self.vector.obj){
                end = self.vector.start.add(self.vector.obj);
            }
            let create = false;
            if (self.vector.item) {
                self.vector.start = end;
                create = true;
            } else if (self.vector.obj && (event.modifiers.option
                    || end && end.getDistance(event.point) < 10)) {
                create = false;
            } else {
                self.vector.start = event.point;
            }
            if (create) {
                self.vector.item = null;
            }
            

            if((this.currentEquipmentConfig || {}).name == "fix_skylight" && 
                self.canvas.shape.segments.length == 3){
                    this.__sections_autoset('canvas');
                    this.__sections_close(event, true);
                    
            }else if(self.isUnitScaleEnabled && self.canvas.shape.segments.length == 2){
                this.__sections_close(event, true);
            }else{
                self.__sections_processVector(event, true);
            }
        },

        __sections_onMouseMove(event){
            let self = this;
            
            if(!self.vector.start) return
            self.__sections_processVector(event, event.modifiers.shift);
        },

        __sections_onMouseDrag(event, self){

            if (self.canvas.shape.selectedSegment) {
                self.canvas.shape.selectedSegment.point.add(event.delta);
            }
        }
    
    }
}